<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1 style="font-family:Arial; font-size:18pt; letter-spacing:1px; padding-top:75px; padding-bottom:15px;">Acknowledgement</h1>
<p style="text-align: center;">I would like to acknowledge the NHS, all associated charities, support teams, and everyone brave enough to come forward for help and treatment.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?0f7f05fb